module.exports = __webpack_public_path__ + "static/media/545.922fc295.webp";